import {NgModule} from "@angular/core";
import {UploadImageImportItemComponent} from "./upload-image-import-item.component";
import {PaginationModule} from "ngx-bootstrap";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import { ImageUploadComponent } from './image-upload/image-upload.component';
import {RouterModule} from "@angular/router";
import {SharedModule} from "../../shared/shared.module";
import {LoadingModule} from "ngx-loading";

@NgModule({
  imports: [
    PaginationModule.forRoot(),
    FormsModule,
    CommonModule,
    RouterModule,
    SharedModule,
    LoadingModule,
  ],
  declarations: [
    UploadImageImportItemComponent,
    ImageUploadComponent,
  ]
})
export class UploadImageImportItemModule {
}
